const validators = {};

export default validators;



// WEBPACK FOOTER //
// ./src/modules/security/validators/action-validators.js